import { useMemo } from 'react';

function useIsHijacked() {
  // Check for hijack popover injected into document
  return useMemo(() => !!document.querySelector('#djhj'), []);
}

export default useIsHijacked;
